
import { GetterTree } from 'vuex';

import { State } from './state';

export type Getters = {
    getGrids(state: State): any
}

export const getters: GetterTree<State, any> & Getters = {
    getGrids: (state) => state.grids,
};
